import React from 'react';

const Messenger: React.FC<{ height?: number; width?: number }> = ({
  height,
  width,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="#FAFAFA" />
      <g clip-path="url(#clip0_206_14943)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 2C6.3675 2 2 6.1275 2 11.7C2 14.615 3.195 17.135 5.14 18.875C5.3025 19.02 5.4025 19.225 5.4075 19.445L5.4625 21.225C5.48 21.7925 6.065 22.1625 6.585 21.9325L8.57 21.0575C8.7375 20.9825 8.9275 20.97 9.105 21.0175C10.0175 21.2675 10.9875 21.4025 12 21.4025C17.6325 21.4025 22 17.275 22 11.7025C22 6.13 17.6325 2 12 2Z"
          fill="url(#paint0_radial_206_14943)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.99495 14.5373L8.93245 9.87725C9.39995 9.13475 10.3999 8.95225 11.1024 9.47725L13.4399 11.2298C13.6549 11.3898 13.9499 11.3898 14.1624 11.2273L17.3174 8.83225C17.7374 8.51225 18.2874 9.01725 18.0074 9.46475L15.0674 14.1223C14.5999 14.8648 13.5999 15.0473 12.8974 14.5223L10.5599 12.7698C10.3449 12.6098 10.0499 12.6098 9.83745 12.7723L6.68245 15.1673C6.26245 15.4873 5.71245 14.9848 5.99495 14.5373Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_206_14943"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.85 21.8911) scale(21.792 21.792)"
        >
          <stop stop-color="#0099FF" />
          <stop offset="0.6098" stop-color="#A033FF" />
          <stop offset="0.9348" stop-color="#FF5280" />
          <stop offset="1" stop-color="#FF7061" />
        </radialGradient>
        <clipPath id="clip0_206_14943">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Messenger;
